module.exports = __webpack_public_path__ + "img/chinesecompany217.d5d1447d.png";